module.exports = __webpack_public_path__ + "img/instagram-icon.75a2114d.png";